import {
  FormControl,
  Input,
  FormErrorMessage,
  Flex,
  FormLabel,
} from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import PrimaryButton from "../PrimaryButton";
import { useMutation, useQueryClient } from "react-query";
import { User } from "../../types/user.types";
import { createPrinter } from "../../mutations/printer.mutations";
import Select from "../inputs/Select";

type CreatePrinterFormProps = {
  onSubmit?: () => void;
};

function CreatePrinterForm({ onSubmit }: CreatePrinterFormProps) {
  const methods = useForm();
  const queryClient = useQueryClient();
  const { mutate: mutateCreatePrinter } = useMutation(createPrinter, {
    onSuccess: () => {
      queryClient.invalidateQueries("printers");
      if (onSubmit) {
        onSubmit();
      }
    },
  });

  const handleSubmit = async () => {
    mutateCreatePrinter({ printer: methods.getValues() as User });
  };

  return (
    <FormProvider {...methods}>
      <form style={{ marginTop: "32px" }}>
        <Flex direction="column" gap="24px">
          <FormControl isInvalid={!!methods.formState.errors.label}>
            <FormLabel>Nom</FormLabel>

            <Input
              id="label"
              placeholder="Nom"
              {...methods.register("label", {
                required: "Ce champ est obligatoire",
              })}
            ></Input>
            <FormErrorMessage>
              <>{methods.formState.errors?.label?.message}</>
            </FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={!!methods.formState.errors.type} mb={6}>
            <FormLabel>Type</FormLabel>
            <Select
              {...methods.register("type", {
                required: "Ce champ est obligatoire",
              })}
            >
              <option value="Imprimante">Imprimante</option>
              <option value="Imprimante UPS">Imprimante UPS</option>
              <option value="Imprimante Etiquettes">Imprimante Etiquettes</option>
            </Select>
            <FormErrorMessage>
              <>{methods.formState.errors?.type?.message}</>
            </FormErrorMessage>
          </FormControl>

          <PrimaryButton type="button" onClick={handleSubmit}>
            Sauvegarder
          </PrimaryButton>
        </Flex>
      </form>
    </FormProvider>
  );
}

export default CreatePrinterForm;
